import AuthenticatedController from './AuthenticatedController';
import * as APIRoutes from '@mm/api-routes';
import ButtonModel from '../model/ButtonModel';

export default class ButtonController extends AuthenticatedController {
  static postButton(
    widgetId: number,
    entity: Partial<ButtonModel>,
  ): Promise<ButtonModel> {
    return super.post(APIRoutes.BUTTONS(widgetId), entity);
  }

  static putButton(
    widgetId: number,
    entity: ButtonModel,
  ): Promise<ButtonModel> {
    return super.put(`${APIRoutes.BUTTONS(widgetId)}/${entity.id}`, entity);
  }

  static deleteButton(widgetId: number, id: number): Promise<any> {
    return super.delete(`${APIRoutes.BUTTONS(widgetId)}/${id}`);
  }

  static postEntry(widgetId: number, entryId: number, entity) {
    return super.post(APIRoutes.ENTRY_BUTTONS(widgetId)(entryId), entity);
  }

  static putEntry(widgetId: number, entryId: number, entity) {
    return super.put(
      `${APIRoutes.ENTRY_BUTTONS(widgetId)(entryId)}/${entity.id}`,
      entity,
    );
  }

  static deleteEntry(widgetId: number, entryId: number, id: number) {
    return super.delete(`${APIRoutes.ENTRY_BUTTONS(widgetId)(entryId)}/${id}`);
  }

  static createButtonBundle(widgetId: number, entity) {
    return super.post(APIRoutes.CREATE_BUTTON_BUNDLE(widgetId), entity);
  }

  static deleteButtonBundle(widgetId: number, buttonId: number) {
    return super.delete(APIRoutes.DELETE_BUTTON_BUNDLE(widgetId, buttonId));
  }
}
